import request from "@/utils/request";

export function queryList (data){
  return request({
    url:'/osp/materialGroup/queryList?orgSaleId=' + data,
    method:'post'

  })
}

export function getMaterialGroupLevel(data){
  return request({
    url:'/osp/materialView/getMaterialGroupLevel',
    method:'post',
    data: data
  })
}

export function queryGroupTree(data){
  return request({
    url:'/osp/materialGroup/queryGroupTree',
    method:'post',
    data: data
  })
}

export function queryPageListGroup(data){
  return request({
    url:'/osp/material/queryMaterials',
    method:'post',
    data: data
  })
}

 export function deleteByIds(data){
  return request({
    url: '/osp/materialCommerce/deleteByIds',
    method: 'post',
    data: data
  })
 }

 export function saveBo (data) {
   return request({
     url: '/osp/materialCommerce/saveBo',
     method: 'post',
     data: data
   })
 }

 export function updateByBo (data) {
   return request({
     url: '/osp/materialCommerce/updateByBo',
     method: 'post',
     data: data
   })
 }

export function queryGroupBySaleOrg (data){
  return request({
    url: '/osp/materialGroup/queryGroupBySaleOrg',
    method: 'post',
    data: data
  })
}
